import * as fromDatatype from '../datatype-library'

export interface bl_applet_to_store_trending_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    applet_hdr_guid: fromDatatype.GuidDataFieldInterface;
    store_hdr_guid: fromDatatype.GuidDataFieldInterface;
    trending_score: fromDatatype.IntegerDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
}

export class bl_applet_to_store_trending_link_RowClass implements bl_applet_to_store_trending_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    applet_hdr_guid: fromDatatype.GuidDataFieldInterface;
    store_hdr_guid: fromDatatype.GuidDataFieldInterface;
    trending_score: fromDatatype.IntegerDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
}